import styled from "styled-components";
import { Link } from "react-router-dom";


export const SkillDetailsWeb = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem auto 0 auto;
  align-items: center;
  gap: 10px;
  padding: 0 20px 20px 20px;
  max-width: 500px;

  @media (min-width: 468px) {
	flex-direction: row;
	align-items:center;
	margin: 10px auto 20px auto;
	}

	@media (min-width: 800px) {
		margin: 20px auto 40px auto;
		padding: 0;
    max-width: 700px;
	}
`;

export const SkillIconWeb = styled.img`
  width: 40px;
  margin: 0;

  @media (min-width: 768px) {
	margin: 0 10px;
	}
`;

export const SkillsListWeb = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style: none;
  gap: 20px;
  padding: 0;
  margin: 10px 0;

  @media (min-width: 768px) {
	justify-content: flex-start;
	}

  @media (min-width: 1024px) {
    align-items: center;
    gap: 40px;
  }
`;

export const SkillItemWeb = styled.li`
  font-size: 16px;
  letter-spacing: 0.5px;
  font-weight: 500;
  color: #252525;

  @media (min-width: 768px) {
		font-size: 18px;
	}

	@media (min-width: 1024px) {
		font-size: 20px;
	}
`;

interface SkillLinkProps {
  to: string;
}

export const SkillWebLink = styled(Link)<SkillLinkProps>`
  color: var(--maindark);
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
  width: fit-content;
  margin: 0 0 1rem 0;
  text-decoration: none;
  cursor: pointer;

  &::after {
    content: "";
    position: absolute;
    width: 0;
    height: 4px;
    bottom: -5px;
    left: 0;
    background-color: var(--bg-pink);
    transform-origin: left;
    transition: width 0.5s ease;
    visibility: hidden;
  }

  &:hover::after {
    visibility: visible;
    width: 100%;
  }
`;
